import commonStrings from 'owa-strings/owa-mini-common-strings';
import getRootStore from 'satcheljs/lib/getRootStore';
import setUserConfiguration from 'owa-session-store/lib/actions/setUserConfiguration';
import showToast from 'mini-toast/lib/utils/showToast';
import { clearSessionStorage } from 'mini-session-storage';
import { createAppContext } from 'mini-app-context';
import { RefreshStrategy } from 'mini-settings/lib/schema/RefreshStrategy';
import { SessionData } from 'owa-service/lib/types/SessionData';
import { SettingsMetaData } from 'mini-settings/lib/schema/SettingsMetaData';
import { showToastWithPromise } from './utils/showToastWithPromise';
import { when } from 'mobx';

export const SETTING_REFRESH_CLICKED = 'SettingRefreshClicked';
export const SETTING_HYDRATION_WITH_MESSAGE = 'SettingsHydrationWithMessage';
export const SETTING_HYDRATION_WITHOUT_MESSAGE = 'SettingsHydrationWithoutMessage';

/**
 * Callback function to show the toast message and perform the further actions
 * @param metadata
 * @param refreshStrategy
 * @param sessionData
 * @param onUnload [optional] Callback to be run when window is unloaded.
 */
const handleOnSettingsChange = async (
    metadata: SettingsMetaData,
    refreshStrategy: RefreshStrategy,
    sessionData: SessionData,
    onUnload?: () => Promise<void>
) => {
    // Wait for strings to be populated.
    await when(
        () =>
            getRootStore()
                .get('locstrings')
                .registeredStringModules.get('owa-mini-common-strings')
                .strings.get('diffToastMessage')
        // we dont get strings, until we access one, so diffToastMessage is one of the strings
    );

    switch (refreshStrategy) {
        case RefreshStrategy.Reload:
            showToast({
                label: commonStrings.diffToastMessage,
                onButtonClick: () => {
                    createAppContext().signal(SETTING_REFRESH_CLICKED);
                    clearSessionStorage();
                    onUnload && window.removeEventListener('unload', onUnload);
                    (window as any).location.reload();
                },
                buttonLabel: commonStrings.diffToastActionButton,
            });
            break;
        case RefreshStrategy.HydrationWithMessage:
            await showToastWithPromise({
                label: commonStrings.diffToastMessage,
                onButtonClick: () => {
                    createAppContext().signal(SETTING_HYDRATION_WITH_MESSAGE);
                    setUserConfiguration(sessionData.owaUserConfig);
                },
                buttonLabel: commonStrings.diffToastActionButton,
            });
            break;
        default:
            createAppContext().signal(SETTING_HYDRATION_WITHOUT_MESSAGE);
            setUserConfiguration(sessionData.owaUserConfig);
    }
};

export default handleOnSettingsChange;
